<template>
  <v-container fluid>
    <a class="v-btn v-btn--contained theme--light v-size--default primary" @click="$router.go(-1)"
      >Вернуться к результатам поиска</a
    >
    <v-row>
      <v-col lg="4" md="12">
        <v-card max-width="400" class="pb-2">
          <v-img class="white--text align-end" height="200px" :src="img" alt="" />
          <v-card-title class="pt-1 pb-0">
            <v-icon v-for="index of 3" :key="index">star</v-icon>
          </v-card-title>
          <v-card-title>ЗДРАВПУНКТ ЛЕНИНСКОГО РЭС</v-card-title>
          <v-card-subtitle class="pb-0">Тула, Щегловская засека 24</v-card-subtitle>
        </v-card>
        <v-btn class="mt-2" color="primary">Записаться на приём</v-btn>
      </v-col>
      <v-col lg="8" md="12">
        <v-row>
          <v-col>
            <v-autocomplete placeholder="Способ оказания услуги"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete placeholder="Выберите услугу"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete placeholder="Выберите услугу"></v-autocomplete>
          </v-col>
        </v-row>
        <v-alert type="info">
          В списках представлены врачи и услуги данной клиники.Пожалуйста, выберите способ оказания, услугу и врача.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import placeholder from "@/assets/img/location-placeholder.png";

export default {
  computed: {
    img() {
      return placeholder;
    },
  },
};
</script>

<style></style>
